<template>
    <f7-page>
        <f7-block class="loading">
            <f7-preloader size="20px"></f7-preloader>
            <br>
            <div>加载中</div>
        </f7-block>
    </f7-page>
</template>

<script type="text/ecmascript-6">
  import { setToken } from 'lib/common'
  import { commonApi } from 'api/api'
  import { globalConst as native } from '../lib/const'
  import { mapState } from 'vuex'

  export default {
    data () {
      return {}
    },
    created () {
      console.log('jump')
    },
    methods: {},
    mounted () {
      this.$nextTick(() => {
        console.log('this', this)
        let {token, hashUrl, macaddr = ''} = this.$f7route.query
        if (!hashUrl) {
          hashUrl = '/home'
        }
        const {commit} = this.$store
        if (!token) {
          this.$f7router.navigate(`/error?message=${encodeURIComponent('无效的访问来源，请从微信菜单进入')}`, {clearPreviousHistory: true})
          return
        }
        const credential = {
          token,
          expireTime: (24 * 60 * 60 * 1000) + new Date().getTime(),
        }
        console.log('store', this.$store)
        // setToken(token)
        commit('doAlreadyBind', credential)
        if (macaddr) {
          commit('setMacAddr', macaddr)
        }
        this.$f7router.navigate(hashUrl, {
          /* animate: false,
           history: false*/
        })
        /* setTimeout(() => {
          this.$f7router.navigate('/home', {})
        }, 3000)*/
      })
    },
    computed: {
      ...mapState({})
    }
  }
</script>
<style lang="scss" scoped type="text/css">
    .loading {
        text-align: center;
    }
</style>
